import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = {
  key: 1,
  class: "title"
}
const _hoisted_3 = {
  key: 2,
  class: "right"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Collapse = _resolveComponent("Collapse")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["segment", {form: $props.form, raised: $props.raised, padded: $props.padded, red: $props.red, flat: $props.flat, expandable: _ctx.$slots.extra, open: $data.open, hover: $data.hover}]),
    onMousemove: _cache[1] || (_cache[1] = $event => (!$data.open && _ctx.$throttle_200($options.onMouseMove, $event))),
    onMouseleave: _cache[2] || (_cache[2] = $event => (!$data.open && $options.stopHover())),
    onClick: _cache[3] || (_cache[3] = (...args) => ($options.onSegment && $options.onSegment(...args)))
  }, [
    (_ctx.$slots['header-left'] || $props.title || _ctx.$slots['header-right'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.$slots['header-left'])
            ? _renderSlot(_ctx.$slots, "header-left", { key: 0 }, undefined, true)
            : ($props.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
          (_ctx.$slots['header-right'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "header-right", {}, undefined, true)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default", { class: "content" }, undefined, true),
    (_ctx.$slots.extra)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_Collapse, {
            open: $data.open,
            "keep-alive": ""
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "extra", {}, undefined, true)
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["open"]),
          _createElementVNode("div", {
            class: "expand pointer",
            onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.toggleExpand && $options.toggleExpand(...args)), ["stop"]))
          }, [
            _createTextVNode(_toDisplayString($data.open ? 'Collapse' : 'Expand') + " ", 1 /* TEXT */),
            _createVNode(_component_Icon, {
              class: "icon",
              icon: "chevron-down",
              width: "2.4rem",
              height: "2.4rem"
            })
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 34 /* CLASS, NEED_HYDRATION */))
}